import React from "react";
import { analyticsBusTravelApi } from "../../services/AnalyticService";
import { useState, useEffect } from "react";
import { Spinner } from "react-bootstrap";
import Chart from "react-apexcharts";
const DistanceDistributionChart = ({ data }) => {
  const categories = data.map((item) => item.range);
  const seriesData = data.map((item) => item.bus_count);
  const options = {
    chart: {
      type: "bar",
      toolbar: { show: false },
      fontFamily: "Arial, sans-serif",
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 6,
      },
    },
    dataLabels: {
      enabled: true,
      style: {
        fontSize: "12px",
      },
    },
    xaxis: {
      categories,
      title: {
        // text: "Distance Range",
        style: { fontWeight: 600 },
      },
      labels: {
        rotate: -45,
      },
    },
    yaxis: {
      title: {
        // text: "Number of Buses",
        style: { fontWeight: 600 },
      },
    },
    colors: ["#482807"],
    tooltip: {
      custom: function ({ dataPointIndex }) {
        const buses = data[dataPointIndex]?.buses || [];
        if (buses.length === 0) {
          return `<div style="padding: 8px; font-size: 14px;">No buses in this range</div>`;
        }

        return (
          `<div style="padding:6px; font-size: 13px; max-width: 250px;color:#f9f9f9; background-color: #482807;">` +
          buses
            .map(
              (bus) => `
            <div style="margin-bottom: 6px; padding: 8px; border-left: 2px solid #f9f9f9; background-color: #482807;">
              <div><strong>Number:</strong> ${bus.number_plate}</div>
              <div><strong>Distance:</strong> ${bus.total_distance_km} km</div>
            </div>
          `
            )
            .join("") +
          `</div>`
        );
      },
    },
    stroke: {
      colors: ["#fff"],
    },
    legend: {
      show: false,
    },
  };

  const series = [
    {
      name: "Bus Count",
      data: seriesData,
    },
  ];

  return <Chart options={options} series={series} type="bar" height={280} />;
};
const BusTravel = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [param, setParam] = useState({
    report_type: "this_month",
  });
  useEffect(() => {
    setLoading(true);
    analyticsBusTravelApi(param)
      .then((res) => {
        setData(res?.data?.distribution || []);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [param]);
  return (
    <>
      <div className="card overflow-hidden">
        <div className="p-2 d-flex justify-content-between">
          <span className="text-primary" style={{ fontWeight: "500" }}>
            Bus Travel
          </span>
          <div className="btn-group align-self-start">
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.report_type === "this_month" ? "active" : ""
              }`}
              onClick={() => setParam({ report_type: "this_month" })}
            >
              1M
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.report_type === "last_3_months" ? "active" : ""
              }`}
              onClick={() => setParam({ report_type: "last_3_months" })}
            >
              3M
            </button>
            <button
              className={`btn btn-sm btn-outline-primary ${
                param.report_type === "last_6_months" ? "active" : ""
              }`}
              onClick={() => setParam({ report_type: "last_6_months" })}
            >
              6M
            </button>
          </div>
        </div>
        <div className="card-body">
          {loading ? (
            <div className="text-center my-2">
              <Spinner animation="border" size="sm" />
              <span className="ms-1">Loading...</span>
            </div>
          ) : data?.length == 0 ? (
            <div className="text-center my-2">No Data Found</div>
          ) : (
            <DistanceDistributionChart data={data} />
          )}
        </div>
      </div>
    </>
  );
};

export default BusTravel;
